export default "__VITE_ASSET__z7Eb1J8z__"